<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput"
        v-on:form-change="onFormChange" >

        <div 
          slot="jt-form-slot-billingTnc">
          <label> Billing Terms and Conditions</label> 
          <div
            id="billingTnc"
            class="summernote" />
        </div>

        <div 
          slot="jt-form-slot-cpid">
          <label>Snatch Car Park IDs</label> 
          <br>* Press Enter after typing each Car Park ID

          <vue-tags-input
              v-model="cpid_tag"
              placeholder="Add Snatch Car Park IDs"
              :tags="cpid_tags"
              @tags-changed="cpid_newTags => cpid_tags = cpid_newTags"
              :disabled="!cpid_allowEdit"
            />
        </div>

      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>
      <button v-show="hasAddOrEditPermission()" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Save
      </button>
      <button v-show="hasDeletePermission() && !pageIsAdd && pageCanDelete" v-on:click="onDeleteButtonClick" type="button" class="btn btn-danger">
        Delete
      </button>

      <TemplateModal
        v-bind:modalId="deleteModalId">
        <h4 slot="modal-title" class="modal-title" >
          {{ deleteModalTitle || 'Confirm Delete' }}
        </h4>
        <div slot="modal-body">
          {{ deleteModalBody || 'Are you sure you want to delete the selected item?' }}
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onDeleteConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import VueTagsInput from '@johmun/vue-tags-input';

var querystring = require('querystring');

let boostrapGridCol6 = {
  'class': 'col-lg-6',
};

const PARAM = [
  {
    form_section: 'Car Park Management',
  },
  {
    key: 'carparkCode',
    text: 'Car Park Code *',
  },
  {
    key: 'name',
    text: 'Car Park Name *',
  },
  {
    key: 'image',
    text: 'Car Park Image',
    form_label: 'Car Park Image (Horizantal: 400 Vertical: 400)',
    form_dropzone: true,
    form_dropzone_width: 400,
    form_dropzone_height: 400,
    form_input_validation: [],
    width: '200px',
  },
  {
    // key: '_startHour',
    key: 'operationHourStart',
    text: 'Operating Start Hour',
    form_clockpicker: true,
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    // key: '_stopHour',
    key: 'operationHourStop',
    text: 'Operating End Hour',
    form_clockpicker: true,
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'bay',
    text: 'Total Bay Count *',
    form_input_attr: {
      'type': 'Number',
    },
    form_input_validation: [validation.validateRequire, validation.validatePositive],
  },
  {
    form_section: 'Car Park Contact',
  },
  {
    key: 'phone1',
    text: 'Phone No. 1 *',
    form_container_attr: boostrapGridCol6,
    form_phone: true,
  },
  {
    key: 'phone2',
    text: 'Phone No. 2',
    form_container_attr: boostrapGridCol6,
    form_phone: true,
    form_input_validation: [],
  },
  {
    form_section: 'Car Park Address',
  },
  {
    key: 'address1',
    text: 'Address 1 *',
  },
  {
    key: 'address2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'address3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'addressPostalCode',
    text: 'Postal Code *',
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'cityID',
    text: 'City *',
    form_container_attr: boostrapGridCol6,
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'addressState',
    text: 'State *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
  {
    key: 'addressCountry',
    text: 'Country *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
  {
    form_section: 'Car Park Geolocation',
  },
  {
    key: 'searchLocation',
    text: 'Search Location',
    form_input_validation: [],
  },
  {
    key: 'googleMap',
    form_div: true,
    form_div_attr: {
      id: 'jt-form-div-googleMap',
      style: {
        width: '100%', 
      }
    },
  },
  {
    key: 'lat',
    text: 'Latitude',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'type': 'Number',
    },
    form_input_validation: [],
  },
  {
    key: 'lon',
    text: 'Longitude',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'type': 'Number',
    },
    form_input_validation: [],
  },
  {
    form_section: 'Car Park Operation',
  },
  {
    key: '_startDate',
    text: 'Car Park Operation Start Date *',
    form_datepicker: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: '_endDate',
    text: 'Car Park Operation End Date',
    form_datepicker: true,
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    form_section: 'Car Park Setting',
  },
  {
    key: 'contractType',
    text: 'Car Park Contract Type',
    form_select: [{1:'Tenancy Deal'}, {2:'Management Deal'}],
    form_input_validation: [],
  },
  {
    form_html: () => 'Parking License Application Commencement Date *',
  },
  {
    key: '_allowHalfMonth',
    text: 'Allow Half Month (1st & 16th)',
    form_checkbox: {
      true_value: 1
    },
  },
  {
    key: '_allowFullMonth',
    text: 'Allow Full Month Only (1st)',
    form_checkbox: {
      true_value: 1
    },
  },
  {
    key: '_allowAnyDay',
    text: 'Allow Any Day of Month',
    form_checkbox: {
      true_value: 0
    },
  },
  {
    key: 'CommencementDate1',
    text: '1st',
    form_invalid: true,
    form_checkbox: {
      true_value: 1
    },
  },
  {
    key: 'CommencementDate2',
    text: '16th',
    form_invalid: true,
    form_checkbox: {
      true_value: 16
    },
  },
  {
    form_html: () => '<hr>',
  },
  {
    key: 'isEnable',
    text: 'Enable Car Park',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'SuspendApplication',
    text: 'Suspend from Parking Application',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  // {
  //   key: 'SiteActivation',
  //   text: 'Passcard Require Site Office Activation',
  //   form_checkbox: true,
  //   form_container_attr: boostrapGridCol6,
  //   form_muted: 'By turning ON, the passcard issuance letter will include the "Please activate your passcard at the car park site office."'
  // },
  {
    key: 'ExemptLatePay',
    text: 'Exemption from Late Payment',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'ExemptStopbBill',
    text: 'Exemption from Stop Billing',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  // {
  //   key: 'ExemptInvoice',
  //   text: 'Exempted from Invoice and Official Receipt Email Notification',
  //   form_checkbox: true,
  //   form_container_attr: boostrapGridCol6,
  // },
  {
    key: 'ExemptSST',
    text: 'Exempted from SST',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'NoSST',
    text: 'Car Park No SST',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'ExclusiveSST',
    text: 'Car Park Exclusive SST',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'ParkaideOnly',
    text: 'ParkAide Enable (Force)',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'ParkaideEnable',
    text: 'ParkAide Enable (Optional)',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'cpid',
    text: 'Snatch Car Park ID',
    // form_tag_input: true,
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_div: true,
  },
  {
    form_section: 'Car Park Fees',
  },
  {
    key: 'Reactivation',
    text: 'Reactivation Fee (RM) *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      type: 'number',
    }
  },
  {
    key: 'LatePenalty',
    text: 'Late Payment Penalty (RM) *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      type: 'number',
    }
  },
  {
    key: 'Reinstatement',
    text: 'Reinstatement Fee (RM) *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      type: 'number',
    }
  },
  {
    form_section: 'Car Park Billing Setting',
  },
  {
    form_html: () => 'This info will appear on Parking License, Invoices, CN, DN and OR.',
  },
  {
    key: 'carparkFinanceCompanyName',
    text: 'Company Name *',
    form_muted: 'Bills Payable To Company Name.',
  },
  {
    key: 'sstNumber',
    text: 'SST Reg No.',
    form_input_validation: [],
  },
  {
    key: 'carparkCompanyAddress1',
    text: 'Address 1 *',
  },
  {
    key: 'carparkCompanyAddress2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'carparkCompanyAddress3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'carparkCompanyAddressPostalCode',
    text: 'Postal Code *',
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'carparkCompanyAddressCityID',
    text: 'City *',
    form_container_attr: boostrapGridCol6,
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'carparkCompanyAddressStateID',
    text: 'State *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_input_validation: [],
  },
  {
    key: 'carparkCompanyAddressCountryID',
    text: 'Country *',
    form_container_attr: boostrapGridCol6,
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_input_validation: [],
  },
  {
    key: 'telephone',
    text: 'Telephone',
    form_container_attr: boostrapGridCol6,
    form_phone: true,
    form_input_validation: [],
  },
  {
    key: 'fax',
    text: 'Fax',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'email',
    text: 'Email',
    form_container_attr: boostrapGridCol6,
    form_email: true,
    form_input_validation: [],
  },
  {
    key: 'website',
    text: 'Website',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'logoHeader',
    text: 'Header Logo (1000px x 70px)',
    width: '100%',
    form_dropzone: true,
    form_dropzone_width: 1000,
    form_dropzone_height: 70,
    form_input_validation: [],
  },
  {
    key: 'logoFooter',
    text: 'Footer Logo (1000px x 150px)',
    width: '100%',
    form_dropzone: true,
    form_dropzone_width: 1000,
    form_dropzone_height: 150,
    form_input_validation: [],
  },
  {
    key: 'billingTnc',
    text: 'Billing Terms and Conditions',
    form_div: true,
    // form_summernote: true,
    form_input_validation: [],
  },
  {
    key: 'test5',
    form_div: true,
  },
  {
    form_html: () => 'Payment Method',
  },
  {
    key: 'Giro',
    text: 'Giro',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'Cheque',
    text: 'Cheque (Site)',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  {
    key: 'Cash',
    text: 'Cash (Site)',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  // {
  //   key: 'EWallet',
  //   text: 'E-Wallet',
  //   form_checkbox: true,
  //   form_container_attr: boostrapGridCol6,
  // },
  {
    key: 'OnlinePayment',
    text: 'Online Banking',
    form_checkbox: true,
    form_container_attr: boostrapGridCol6,
  },
  // {
  //   key: 'CreditCard',
  //   text: 'Credit Card',
  //   form_checkbox: true,
  //   form_container_attr: boostrapGridCol6,
  // },
  // {
  //   key: 'Fpx',
  //   text: 'Bank Transfer via FPX',
  //   form_checkbox: true,
  //   form_container_attr: boostrapGridCol6,
  // },
  {
    form_section: 'General Document Setting',
  },
  {
    key: 'logoHeader1',
    text: 'Header Logo (1000px x 70px)',
    width: '100%',
    form_dropzone: true,
    form_dropzone_width: 1000,
    form_dropzone_height: 70,
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageCarParkForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    TemplateModal,
    AppForm,
    VueTagsInput,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park' },
      ],

      API_PATH: "/api2/carpark/",
      PARAM,
      PARAM_MAP,

      deleteModalId: null,
      deleteModalTitle: null,
      deleteModalBody: null,

      pageIsAdd: true,
      pageTitle: null,
      pageShowData: false,
      pageCanDelete: false,

      googleMap: null,
      googleMapMarkers: [],

      cpid_visible: false,
      cpid_tag: '',
      cpid_tags: [],
      cpid_allowEdit: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.deleteModalId = "jt-popup-modal-" + this._uid + '-delete';

    this.$nextTick(() => {
      helper.setSidebar('/carpark');
    });

    $('#billingTnc').summernote({
      minHeight: '300px'
    });

    this.PARAM_MAP['cpid']['form_hide'] = !helper.hasPermission('carpark.cpid', false)
    this.cpid_allowEdit = helper.hasPermission('carpark.cpid_edit', false)

    this.loadCountry();
    this.loadGoogleMap();
  },
  methods: {
    loadGoogleMap() {
      window.initGoogleMap = this.initGoogleMap;
      const googleMapScript = document.createElement('SCRIPT');
      googleMapScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAngsb_UC9IeYS1GAWy3Nv2_pRrsd245LY&callback=initGoogleMap')
      googleMapScript.setAttribute('async', '')
      googleMapScript.setAttribute('defer', '')
      document.head.appendChild(googleMapScript)
    },
    initGoogleMap() {
      if(!this.pageShowData || !window.google) {
        return;
      }
      
      var coordinate, zoom;
      if(this.$refs['pageForm'].formData &&
        !isNaN(this.$refs['pageForm'].formData.lat) &&
        !isNaN(this.$refs['pageForm'].formData.lon)) {
        coordinate = {lat: this.$refs['pageForm'].formData.lat, lng: this.$refs['pageForm'].formData.lon};
        zoom = 8;
      } else {
        coordinate = {lat: 3.1390, lng: 101.6869};
        zoom = 6;
      }
      
      let googleMapElement = document.getElementById('jt-form-div-googleMap');
      googleMapElement.style.height = '400px';
      this.googleMap = new google.maps.Map(googleMapElement, {
        center: coordinate,
        zoom: zoom
      });

      let self = this;
      this.googleMap.addListener('click', function(e) {
        self.updateFormCoordinate(e.latLng.lat(), e.latLng.lng());
      });

      if(this.$refs['pageForm'].formData &&
        !isNaN(this.$refs['pageForm'].formData.lat) &&
        !isNaN(this.$refs['pageForm'].formData.lon)) {
        self.updateFormCoordinate(this.$refs['pageForm'].formData.lat, this.$refs['pageForm'].formData.lon);
      }
    },
    updateGoogleMapMarker() {
      var lat = Number(this.$refs['pageForm'].formData.lat);
      var lon = Number(this.$refs['pageForm'].formData.lon);
      
      this.googleMapMarkers.forEach(k => k.setMap(null));
      this.googleMapMarkers = [];

      if(isNaN(lat) || isNaN(lon) || !this.googleMap) {
        return;
      }

      let position = {lat: lat, lng: lon};
      this.googleMapMarkers.push(new google.maps.Marker({
        position: position,
        map: this.googleMap,
      }));
      this.googleMap.panTo(position);
    },
    updateFormCoordinate(lat, lng) {
      this.$refs['pageForm'].formData.lat = lat;
      this.$refs['pageForm'].formData.lon = lng;
      this.updateGoogleMapMarker();
    },
    loadGeocode(searchText, input) {
      input.setInputError('Loading...');
      this.$http.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchText}&key=AIzaSyAngsb_UC9IeYS1GAWy3Nv2_pRrsd245LY`)
        .then(response => this.processGeocodeResult(response, input))
        .catch(error => this.processGeocodeResult(error, input));
    },
    processGeocodeResult(response, input) {
      let error;
      if(response && response.data) {
        let status = response.data.status;
        if(status === "OK") {
          var location = response.data.results[0].geometry.location;
          this.updateFormCoordinate(location.lat, location.lng);
        } else if(status === "ZERO_RESULTS") {
          error = 'No Results';
        } else if(status === "OVER_QUERY_LIMIT") {
          error = 'Overy Query Limit';
        } else if(status === "REQUEST_DENIED") {
          error = 'Request Denied';
        } else if(status === "INVALID_REQUEST") {
          error = 'Invalid Request';
        } else if(status === "UNKNOWN_ERROR") {
          error = 'Unknown Error';
        } else {
          error = 'Problem searching location.';
        }
      } else {
        error = 'Problem searching location.';
      }
      
      input.setInputError(error);
    },

    loadCountry() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading country data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/country',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['addressCountry'], response.data);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkCompanyAddressCountryID'], response.data);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'country data'));
        });
    },
    loadState() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading state data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/state',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['addressState'], response.data);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkCompanyAddressStateID'], response.data);
          this.loadCity();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'state data'));
        });
    },
    loadCity() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading city data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/city',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['cityID'], response.data);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkCompanyAddressCityID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'city data'));
        });
    },
    loadData() {
      let carparkID = this.$route.query.carparkID;

      if(carparkID) {
        this.pageIsAdd = false;
        this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
        
        this.$http
          .get(
            helper.SERVER_URL + this.API_PATH + carparkID,
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = response.data[0];
            if(tempData) {
              this.pageTitle = 'Edit ' + tempData.name;
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.loadDataComplete(tempData);
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading car park data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
          })
      } else {
        this.pageIsAdd = true;
        this.pageTitle = 'Create New Car Park';
        this.loadEverythingComplete(true);
      }
    },
    loadDataComplete(tempData) {
      // TODO replace parameter
      // tempData['_startHour'] = tempData['startHour'];
      // tempData['_stopHour'] = tempData['stopHour'];

      this.pageCanDelete = true;
      // this.pageCanDelete = !tempData['isEnable'];

      // tempData['_startHour'] = helper.parseDateTime(tempData['startHour']).format('HH:mm');
      // tempData['_stopHour'] = helper.parseDateTime(tempData['stopHour']).format('HH:mm');
      this.loadCarparkSeason(tempData);
    },
    loadCarparkSeason(tempData) {
      let feedbackItem = 'car park season data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + this.API_PATH + tempData.id + '/seasonSetting',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData = Object.assign(response.data[0] || {}, tempData);
          tempData['_startDate'] = helper.formatDate(tempData['startDate']);
          tempData['_endDate'] = helper.formatDate(tempData['endDate']);
          this.$refs['pageFeedback'].setFeedbackMessage();

          if(tempData['CommencementDate1'] === 1 && tempData['CommencementDate2'] === 16) {
            tempData['_allowHalfMonth'] = 1;
          } else if(tempData['CommencementDate1'] === 1) {
            tempData['_allowFullMonth'] = 1;
          } else {
            tempData['_allowAnyDay'] = 1;
          }

          this.loadCarparkTnC(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkTnC(tempData) {
      let feedbackItem = 'car park terms and conditions';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + this.API_PATH + tempData.id + '/tnc',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data.length > 0) {
            $('#billingTnc').summernote('code', this.lastTnc = response.data[response.data.length - 1].tnc);
          }

          this.loadCarparkFinance(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkFinance(tempData) {
      let feedbackItem = 'car park finance data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + this.API_PATH + tempData.id + '/finance',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData['carparkFinanceCompanyName'] = (response.data[0] || {})['name'];
          tempData['carparkFinanceCompanyAddress'] = (response.data[0] || {})['addressData1'];
          tempData = Object.assign(response.data[0] || {}, tempData);
          this.$refs['pageFeedback'].setFeedbackMessage();
          if(tempData['carparkFinanceCompanyAddress']) {
            this.loadCarparkFinanceCompanyAddress(tempData);
          } else {
            this.loadCarparkSeasonComplete(tempData);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkFinanceCompanyAddress(tempData) {
      let feedbackItem = 'car park company address';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + tempData['carparkFinanceCompanyAddress'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData = Object.assign(helper.parseAddress(response) || {}, tempData);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadCarparkSeasonComplete(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkSeasonComplete(tempData) {
      if(tempData.addressData1) {
        this.loadAddress(tempData);
      } else {
        this.loadEverythingComplete(false, tempData);
      }
    },
    loadAddress(tempData) {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park address data...');
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + tempData.addressData1,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          tempData = Object.assign(helper.parseAddress(response) || {}, tempData);
          this.loadCPID(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park address data'));
        })
    },
    loadCPID(tempData) {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading Snatch Car Park ID...');
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + tempData.id + '/reference',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.cpid_tag = ''
          this.cpid_tags = response.data.references.map(k => k.referenceID)
          this.loadAddressComplete(tempData);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'Snatch Car Park ID'));
        })
    },
    loadAddressComplete(tempData) {
      this.loadEverythingComplete(false, tempData);
    },
    loadEverythingComplete(formIsAdd, formData) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageForm'].setForm(formIsAdd, formData);
      this.onFormCityChange();
      this.onFormCompanyCityChange();
      this.pageShowData = true;
      this.initGoogleMap();
    },

    onCancelButtonClick() {
      helper.redirect(helper.WEB_URL + '/carpark');
    },
    isAnyChecked(formData, ...value) {
      for(let key of value) {
        if(parseInt(formData[key])) {
          return true;
        }
      }
      return false;
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm()) {
        let formData = this.$refs['pageForm'].formData;

        if(!this.isAnyChecked(formData, '_allowHalfMonth', '_allowFullMonth', '_allowAnyDay')) {
          this.$refs['pageForm'].$refs['jt-form-element-_allowAnyDay'][0].setInputError('Please select valid Parking License Application commencement date.');
          return;
        }
        this.$refs['pageForm'].$refs['jt-form-element-_allowAnyDay'][0].setInputError();
        
        if(!this.isAnyChecked(formData, 'OnlinePayment', 'Giro', 'Cheque', 'Cash', 'EWallet', 'CreditCard', 'Fpx')) {
          this.$refs['pageForm'].$refs['jt-form-element-Cash'][0].setInputError('Please select at least one payment method.');
          return;
        }
        this.$refs['pageForm'].$refs['jt-form-element-Cash'][0].setInputError();

        // TODO replace parameter
        // formData['startHour'] = formData['_startHour'];        
        // formData['stopHour'] = formData['_stopHour'];

        // let startHour = formData['_startHour'].split(':');
        // formData['startHour'] = moment().set('hour', startHour[0]).set('minute', startHour[1]).utc().format('HH:mm');
        // let stopHour = formData['_stopHour'].split(':');
        // formData['stopHour'] = moment().set('hour', stopHour[0]).set('minute', stopHour[1]).utc().format('HH:mm');
        formData['startDate'] = helper.parseDateTime(formData['_startDate']).unix();
        formData['endDate'] = formData['_endDate'] ? helper.parseDateTime(formData['_endDate']).unix() : formData['_endDate'];

        this.upsertAddress({});
      }
    },
    onDeleteButtonClick() {
      let formData = this.$refs['pageForm'].formData;
      if(formData['isEnable']) {
        alert('Only disabled car park can be deleted');
        return;
      }

      this.deleteModalTitle = `Confirm Delete ${formData.name}?`;
      this.deleteModalBody = `Are you sure you want to delete ${formData.name}?`;
      $('#' + this.deleteModalId).modal('show');
    },
    async onDeleteConfirmClick() {
      $('#' + this.deleteModalId).modal('hide');

      let formData = this.$refs['pageForm'].formData;
      let feedbackItem = formData['name'];
      let selectedData = formData;

      this.$refs['pageFeedback'].setFeedbackLoading('Checking parking license data for ' + feedbackItem);
      if(await this.$http
        .get(
          helper.SERVER_URL + '/api2/license?carparkID=' + selectedData['carparkID'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID'])).length;
        })) {
        this.$refs['pageFeedback'].setFeedbackError('This car park has associated parking license, unable to delete.');
        return;
      }

      this.$refs['pageFeedback'].setFeedbackLoading('Checking parking license application data for ' + feedbackItem);
      if(await this.$http
        .get(
          helper.SERVER_URL + '/api2/request?carparkID=' + selectedData['carparkID'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID'])).length;
        })) {
        this.$refs['pageFeedback'].setFeedbackError('This car park has associated parking license application, unable to delete.');
        return;
      }

      this.$refs['pageFeedback'].setFeedbackLoading('Checking tenant data for ' + feedbackItem);
      if(await this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant?carparkID=' + selectedData['carparkID'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID'])).length;
        })) {
        this.$refs['pageFeedback'].setFeedbackError('This car park has associated tenant profile, unable to delete.');
        return;
      }

      this.$refs['pageFeedback'].setFeedbackLoading('Deleting ' + formData.name);
      this.$http
        .delete(
          `${helper.SERVER_URL}/api2/city/${formData.cityID}/carpark/${formData.id}`,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + formData.name);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },

    upsertAddress(data) {
      this.addAddress(data);
      // if(this.$refs['pageForm'].formIsAdd) {
      //   this.addAddress(data);
      // } else {
      //   if(this.$refs['pageForm'].formData.addressData1) {
      //     this.editAddress(data);
      //   } else {
      //     this.addAddress(data);
      //   }
      // }
    },
    addAddress(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' address');
      
      let formData = this.$refs['pageForm'].formData;
      let temp = {};
      temp['phone1'] = formData['phone1'];
      temp['phone2'] = formData['phone2'];
      temp['address1'] = formData['address1'];
      temp['address2'] = formData['address2'];
      temp['address3'] = formData['address3'];
      temp['addressPostalCode'] = formData['addressPostalCode'];

      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/',
          querystring.stringify({'address': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          formData.addressData1 = response.data;
          this.upsertAddressComplete(data, `Successfully added ${this.$refs['pageForm'].formData.name} address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'address data'));
        })
    },
    editAddress(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + this.$refs['pageForm'].formData.name + ' address');
      
      let formData = this.$refs['pageForm'].formData;
      let temp = {};
      temp['phone1'] = formData['phone1'];
      temp['phone2'] = formData['phone2'];
      temp['address1'] = formData['address1'];
      temp['address2'] = formData['address2'];
      temp['address3'] = formData['address3'];
      temp['addressPostalCode'] = formData['addressPostalCode'];

      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/' + this.$refs['pageForm'].formData.addressData1,
          querystring.stringify({'address': JSON.stringify(temp)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          formData.addressData1 = response.data;
          this.upsertAddressComplete(data, `Successfully update ${this.$refs['pageForm'].formData.name} address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'address data'));
        })
    },
    upsertAddressComplete(data, message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.upsertData(data);
    },

    formCarparkSeasonFormData(formData, carparkID) {
      let tempData = {};
      tempData['carparkID'] = carparkID;
      tempData['CommencementDate1'] = formData['CommencementDate1'];
      tempData['CommencementDate2'] = formData['CommencementDate2'];
      tempData['ExemptLatePay'] = formData['ExemptLatePay'] || 0;
      tempData['ExemptInvoice'] = formData['ExemptInvoice'] || 0;
      tempData['ExemptSST'] = formData['ExemptSST'] || 0;
      tempData['ExemptStopbBill'] = formData['ExemptStopbBill'] || 0;
      tempData['LicenseCreateTnCData'] = formData['LicenseCreateTnCData'] || 0;
      tempData['LicenseTerminateTnCData'] = formData['LicenseTerminateTnCData'] || 0;
      tempData['NoSST'] = formData['NoSST'] || 0;
      tempData['ExclusiveSST'] = formData['ExclusiveSST'] || 0;
      tempData['ParkaideOnly'] = formData['ParkaideOnly'] || 0;
      tempData['ParkaideEnable'] = formData['ParkaideEnable'] || 0;
      tempData['PasscardIssuenceData'] = formData['PasscardIssuenceData'] || 0;
      tempData['SiteActivation'] = formData['SiteActivation'] || 0;
      tempData['SuspendApplication'] = formData['SuspendApplication'] || 0;
      tempData['endDate'] = formData['endDate'] || 0;
      tempData['startDate'] = formData['startDate'];
      tempData['Giro'] = formData['Giro'] || 0;
      tempData['Cheque'] = formData['Cheque'] || 0;
      tempData['Cash'] = formData['Cash'] || 0;
      tempData['OnlinePayment'] = formData['OnlinePayment'] || 0;
      tempData['EWallet'] = formData['EWallet'] || 0;
      tempData['CreditCard'] = formData['CreditCard'] || 0;
      tempData['Fpx'] = formData['Fpx'] || 0;
      tempData['Reactivation'] = formData['Reactivation'];
      tempData['Reinstatement'] = formData['Reinstatement'];
      tempData['LatePenalty'] = formData['LatePenalty'];
      tempData['ReservedCount'] = 0;
      tempData['TandemCount'] = 0;
      tempData['NonReservedCount'] = 0;
      tempData['MotorcycleCount'] = 0;
      return tempData;
    },
    formCarparkFinanceFormData(formData, carparkID) {
      let tempData = {};
      tempData['carparkID'] = carparkID;
      tempData['name'] = formData['carparkFinanceCompanyName'];
      tempData['addressData1'] = formData['carparkFinanceCompanyAddress'];
      tempData['logoFooter'] = formData['logoFooter'];
      tempData['logoHeader'] = formData['logoHeader'];
      tempData['logoHeader1'] = formData['logoHeader1'];
      tempData['sstNumber'] = formData['sstNumber'];
      return tempData;
    },
    formCarparkFinanceAddressFormData(formData) {
      let temp = {};
      temp['carparkCompanyAddress1'] = formData['carparkCompanyAddress1'];
      temp['carparkCompanyAddress2'] = formData['carparkCompanyAddress2'];
      temp['carparkCompanyAddress3'] = formData['carparkCompanyAddress3'];
      temp['carparkCompanyAddressPostalCode'] = formData['carparkCompanyAddressPostalCode'];
      temp['carparkCompanyAddressCityID'] = formData['carparkCompanyAddressCityID'];
      // temp['carparkCompanyAddressCity'] = formData['carparkCompanyAddressCity'];
      // temp['carparkCompanyAddressStateID'] = formData['carparkCompanyAddressStateID'];
      // temp['carparkCompanyAddressState'] = formData['carparkCompanyAddressState'];
      // temp['carparkCompanyAddressCountryID'] = formData['carparkCompanyAddressCountryID'];
      // temp['carparkCompanyAddressCountry'] = formData['carparkCompanyAddressCountry'];
      return temp;
    },

    upsertData(data) {
      if(this.$refs['pageForm'].formIsAdd) {
        this.addData(data);
      } else {
        this.editData(data);
      }
    },


    saveCPID(data) {
      let formData = this.$refs['pageForm'].formData;
      
      let temp = this.cpid_tags.map(k => k.text)
      this.$refs['pageFeedback'].setFeedbackLoading('Saving Snatch Car Park ID');
      
      let config = helper.createAxiosConfig()
      // config['headers']['content-type'] = 'application/json'

      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + (data['carparkID'] || formData['id']) + '/reference',
          {
            referenceIDs: temp, 
          },
          config,
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data) {
            if(this.$refs['pageForm'].formIsAdd) {
              this.addCarparkSeason(data);
            } else {
              this.editCarparkSeason(data);
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem saving Snatch Car Park ID.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', 'Snatch Car Park ID'));
        })
    },

    addData(data) {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + formData.name);

      let url = helper.SERVER_URL + '/api2';
      // if(formData.cityID) {
      //   url += '/city/' + formData.cityID;
      // }
      url += '/carpark/';
      
      let tempData = formData;
      
      this.$http
        .post(
          url,
          querystring.stringify(tempData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + this.$refs['pageForm'].formData.name);
          data.carparkID = response.data[0].id;
          this.saveCPID(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    addCarparkSeason(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' season data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);

      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + data.carparkID + '/seasonSetting',
          querystring.stringify(this.formCarparkSeasonFormData(formData, data.carparkID)),
          // querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          this.upsertCarparkCompanyAddress(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addCarparkFinance(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' finance data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + data.carparkID + '/finance',
          querystring.stringify(this.formCarparkFinanceFormData(formData, data.carparkID)),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          this.addCarparkTnc(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addCarparkTnc(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' terms and conditions';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + data.carparkID + '/tnc',
          querystring.stringify({ tnc : $('#billingTnc').summernote('code') }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          this.addLevel(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addLevel(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' default level');

      this.$http
        .post(
          helper.SERVER_URL + this.API_PATH + data.carparkID + '/level/',
          querystring.stringify({ name: 'Ground', image: ''}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + this.$refs['pageForm'].formData.name + ' default level');
          data.levelID = response.data[0].id;
          this.addZone(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', ' default level'));
        })
    },
    addZone(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' default zone');

      this.$http
        .post(
          helper.SERVER_URL + this.API_PATH + data.carparkID + '/zone/',
          querystring.stringify({ name: 'Default Zone', image: ''}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + this.$refs['pageForm'].formData.name + ' default zone');
          data.zoneID = response.data[0].id;
          this.addZoneLevel(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', ' default zone'));
        })
    },
    addZoneLevel(data) {
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + this.$refs['pageForm'].formData.name + ' default zone level');

      this.$http
        .post(
          helper.SERVER_URL + this.API_PATH + data.carparkID + '/zone/' + data.zoneID + '/zlevel/',
          querystring.stringify({ name: 'Default Zone Level', levelID: data.levelID, image: '' }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + this.$refs['pageForm'].formData.name + ' default zone level');
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', ' default zone level'));
        })
    },
    editData(data) {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + formData.name);

      let url = helper.SERVER_URL + '/api2/carpark/' + formData.id;

      this.$http
        .put(
          url,
          querystring.stringify(this.$refs['pageForm'].formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.saveCPID(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    editCarparkSeason(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' season data';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);

      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + formData['id'] + '/seasonSetting',
          querystring.stringify(this.formCarparkSeasonFormData(formData, formData['id'])),
          // querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertCarparkCompanyAddress(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    editCarparkFinance(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' finance data';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);

      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + formData['id'] + '/finance',
          querystring.stringify(this.formCarparkFinanceFormData(formData, formData['id'])),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.editCarparkTnc(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    editCarparkTnc(data) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = formData['name'] + ' terms and conditions';
      if(this.lastTnc === $('#billingTnc').summernote('code')) {
          this.upsertDataComplete('Successfully updated ' + feedbackItem);
          return;
      }

      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + formData['id'] + '/tnc',
          querystring.stringify({ tnc : $('#billingTnc').summernote('code') }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully updated ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    upsertCarparkCompanyAddress(data) {
      this.addCarparkCompanyAddress(data);
      // if(this.$refs['pageForm'].formIsAdd) {
      //   this.addCarparkCompanyAddress(data);
      // } else {
      //   if(this.$refs['pageForm'].formData.carparkFinanceCompanyAddress) {
      //     this.editCarparkCompanyAddress(data);
      //   } else {
      //     this.addCarparkCompanyAddress(data);
      //   }
      // }
    },
    addCarparkCompanyAddress(data) {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + formData.name + ' car park company address');
      
      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/',
          querystring.stringify({'address': JSON.stringify(this.formCarparkFinanceAddressFormData(formData))}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          formData['carparkFinanceCompanyAddress'] = response.data;
          this.upsertCarparkCompanyAddressComplete(data, `Successfully added ${formData.name} car park company address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'car park company address data'));
        })
    },
    editCarparkCompanyAddress(data) {
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + this.$refs['pageForm'].formData.name + ' car park company address');

      this.$http
        .post(
          helper.SERVER_URL + '/api2/address/' + formData['carparkFinanceCompanyAddress'],
          querystring.stringify({'address': JSON.stringify(this.formCarparkFinanceAddressFormData(formData))}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          formData['carparkFinanceCompanyAddress'] = response.data;
          this.upsertCarparkCompanyAddressComplete(data, `Successfully update ${formData.name} car park company address`);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'car park company address data'));
        })
    },
    upsertCarparkCompanyAddressComplete(data, message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      if(this.$refs['pageForm'].formIsAdd) {
        this.addCarparkFinance(data);
      } else {
        this.editCarparkFinance(data);
      }
    },

    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      helper.redirect(helper.WEB_URL + '/carpark');
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'lat' || formParameter.key === 'lon') {
        this.updateGoogleMapMarker();
      } else if(formParameter.key === 'cityID') {
        this.onFormCityChange();
      } else if(formParameter.key === 'carparkCompanyAddressCityID') {
        this.onFormCompanyCityChange();
      } else if(formParameter.key === 'ParkaideOnly') {
        formData['ParkaideEnable'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'ParkaideEnable') {
        formData['ParkaideOnly'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'ExemptSST') {
        formData['NoSST'] = 0;
        formData['ExclusiveSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'NoSST') {
        formData['ExemptSST'] = 0;
        formData['ExclusiveSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'ExclusiveSST') {
        formData['NoSST'] = 0;
        formData['ExemptSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      }
    },
    onFormCityChange() {
        let formData = this.$refs['pageForm'].formData;
        formData['addressState'] = null;
        formData['addressCountry'] = null;
        
        let selectedCity = helper.inputSelectFindOption(PARAM_MAP['cityID'], formData['cityID']);
        if(!selectedCity) {
          return this.$refs['pageForm'].$forceUpdate();
        }

        let selectedState = helper.inputSelectFindOption(PARAM_MAP['addressState'], selectedCity.stateID);
        if(!selectedState) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['addressState'] = selectedState.id;

        // TODO kw1 map state to country
        let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['addressCountry'], selectedState.countryID);
        if(!selectedCountry) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['addressCountry'] = selectedCountry.id;
        return this.$refs['pageForm'].$forceUpdate();
    },
    onFormCompanyCityChange() {
        let formData = this.$refs['pageForm'].formData;
        formData['carparkCompanyAddressStateID'] = null;
        formData['carparkCompanyAddressCountryID'] = null;
        
        let selectedCity = helper.inputSelectFindOption(PARAM_MAP['carparkCompanyAddressCityID'], formData['carparkCompanyAddressCityID']);
        if(!selectedCity) {
          return this.$refs['pageForm'].$forceUpdate();
        }

        let selectedState = helper.inputSelectFindOption(PARAM_MAP['carparkCompanyAddressStateID'], selectedCity.stateID);
        if(!selectedState) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['carparkCompanyAddressStateID'] = selectedState.id;

        // TODO kw1 map state to country
        let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['carparkCompanyAddressCountryID'], selectedState.countryID);
        if(!selectedCountry) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['carparkCompanyAddressCountryID'] = selectedCountry.id;
        return this.$refs['pageForm'].$forceUpdate();
    },
    onFormChange(formData, formParameter, input) {
      if(formParameter.key === 'searchLocation') {
        this.loadGeocode(formData[formParameter.key], input);
      } else if(formParameter.key === '_allowHalfMonth') {
        this.$nextTick(() => {
          if(helper.compareID(formData['_allowHalfMonth'], 1)) {
            formData['_allowFullMonth'] = 0;
            formData['_allowAnyDay'] = 0;
            formData['CommencementDate1'] = 1;
            formData['CommencementDate2'] = 16;
          } else {
            formData['_allowFullMonth'] = 0;
            formData['_allowAnyDay'] = 1;
            formData['CommencementDate1'] = 0;
            formData['CommencementDate2'] = 0;
          }
          this.$refs['pageForm'].$forceUpdate();
        });
      } else if(formParameter.key === '_allowFullMonth') {
        this.$nextTick(() => {
          if(helper.compareID(formData['_allowFullMonth'], 1)) {
            formData['_allowHalfMonth'] = 0;
            formData['_allowAnyDay'] = 0;
            formData['CommencementDate1'] = 1;
            formData['CommencementDate2'] = 0;
          } else {
            formData['_allowHalfMonth'] = 0;
            formData['_allowAnyDay'] = 1;
            formData['CommencementDate1'] = 0;
            formData['CommencementDate2'] = 0;
          }
          this.$refs['pageForm'].$forceUpdate();
        });
      } else if(formParameter.key === '_allowAnyDay') {
        this.$nextTick(() => {
          if(helper.compareID(formData['_allowAnyDay'], 1)) {
            formData['_allowFullMonth'] = 0;
            formData['_allowHalfMonth'] = 0;
            formData['CommencementDate1'] = 0;
            formData['CommencementDate2'] = 0;
          } else {
            formData['_allowFullMonth'] = 0;
            formData['_allowHalfMonth'] = 0;
            formData['CommencementDate1'] = 0;
            formData['CommencementDate2'] = 0;
          }
          this.$refs['pageForm'].$forceUpdate();
        });
      }
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageCarParkForm.vue